<template>
  <div
    class="card card-primary text-white d-flex align-items-center justify-content-between"
  >
    <p class="pr-1">
      Saudara diharapkan mengisi survei setiap kali mendapat layanan konsultasi
      psikologi.
    </p>
    <button
      class="btn-survey btn btn-warning btn-rounded btn-sm d-inline-flex align-items-center"
      @click="onSurvey()"
    >
      <material-icon
        name="thumbs_up_down"
        type="rounded"
        size="12"
        class="mr-1"
      />
      Ikuti Survei
    </button>
  </div>
</template>

<script>
export default {
  name: "survey-alert",
  methods: {
    onSurvey: function () {
      window.open("http://ugm.id/surveimentalhealth", "_blank");
    },
  },
};
</script>

<style lang="sass" scoped>
.btn-survey
  white-space: nowrap
</style>
